/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import baseLoadable from '@loadable/component';
import {
    ATTRIBUTION_MODE_CHERRYPICK,
    USER_RELATIONSHIP_ATTRIBUTION_ON,
} from '../../../../contexts/AbstractContext';
import {
    FETCH_MODE_FEED,
    Provider as CommunityContextProvider,
} from '../../../../contexts/CommunityContext';
import { loadRightRailLayout } from '../../../../utilities/loadPageContent';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './MasterFeed.scss';

const loadable = (importer) => {
    const withoutForwardRef =
        process.env.__BUILD_TYPE__ === 'client'
            ? (C) => (props) => <C {...props} />
            : (C) => C;

    return withoutForwardRef(baseLoadable(importer));
};
const Feed = loadable(() =>
    import(
        /* webpackPrefetch: true */ '../../../../components/Content/Feed/Feed'
    )
);

const ThreeColumnGridLayout = loadable(() =>
    import(
        /* webpackPrefetch: true */ '../../../../components/Layout/ThreeColumnGridLayout/ThreeColumnGridLayout'
    )
);

const profileLeftRailCTAMetrics = {
    LAT: 'user-left-rail',
    LAC: 'user-left-rail',
    clickMetric: 'user-left-rail-profile-cta-click',
    impressionMetric: 'user-left-rail-profile-cta-impression',
};

const MasterFeed = ({
    PAGE_PROPS: { featureFlags } = {},
    topics,
    currentTopic,
    feedGroup,
    feedGroupId,
    location,
}) => {
    return (
        <div className="page-Community-Feed-MasterFeed">
            <SnowplowPageViewTracker
                pageSection={PAGE_VIEW_SECTIONS.COMMUNITY}
                pageType={PAGE_VIEW_TYPES.FEED}
            />
            <CommunityContextProvider
                fetchMode={FETCH_MODE_FEED}
                attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                content={[]}
                userRelationshipMode={USER_RELATIONSHIP_ATTRIBUTION_ON}
                topics={topics}
                defaultPostLocation={currentTopic}
            >
                <ThreeColumnGridLayout
                    profileLeftRailCTAMetrics={profileLeftRailCTAMetrics}
                    rightRailContent={loadRightRailLayout(
                        'MasterFeed',
                        false,
                        featureFlags
                    )}
                    allowProfileCTA
                    showMobileWand
                    currentTopic={currentTopic}
                    hasTitleCard={!!currentTopic}
                >
                    <Feed
                        topics={topics}
                        feedGroup={feedGroup}
                        feedGroupId={feedGroupId}
                        feedType="masterFeed"
                        createContentEnabled
                        infiniteScroll
                        location={location}
                    />
                </ThreeColumnGridLayout>
            </CommunityContextProvider>
        </div>
    );
};

export default MasterFeed;

MasterFeed.propTypes = {
    /**
     * array of topics for topic menu
     */
    topics: PropTypes.arrayOf(PropTypes.object).isRequired,
    PAGE_PROPS: PropTypes.shape({
        featureFlags: PropTypes.object.isRequired,
    }).isRequired,
    feedGroup: PropTypes.string.isRequired,
    feedGroupId: PropTypes.string.isRequired,
    currentTopic: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        content: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.string,
                number: PropTypes.number,
            })
        ),
        total: PropTypes.number,
        sponsored: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }),
        qaDataAttr: PropTypes.string,
    }),
    location: PropTypes.string,
};

MasterFeed.defaultProps = {
    currentTopic: null,
    location: 'masterFeed',
};
